import HighchartsReactModule from 'highcharts-react-official'

/**
 * O pre-bundler do Vite 8 não resolve corretamente o interop CJS/ESM do build UMD de
 * "highcharts-react-official": em vez do componente, o import default vira o objeto de
 * exports inteiro do módulo (que ainda guarda o componente em `.default`). Fazendo o
 * unwrap manualmente aqui cobrimos os dois casos, com ou sem o bug de interop.
 */
export default HighchartsReactModule?.default ?? HighchartsReactModule
